import { render } from "./Point.vue?vue&type=template&id=447713f9&scoped=true&ts=true"
import script from "./Point.vue?vue&type=script&lang=ts"
export * from "./Point.vue?vue&type=script&lang=ts"

import "./Point.vue?vue&type=style&index=0&id=447713f9&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447713f9"]])

export default __exports__